import { createDefaultEntityStructure } from 'client/utils/createStructureUtils'
import { createWebsiteButtonFromLibrary } from 'src/editor/pages/website/create-website-button-from-library'
import {
  CommonLibraryElementsStructuresCreator,
  CreatorArgs,
} from 'src/editor/shared/entities/common-library-elements-structures-creator'
import { createWebsiteButton } from 'src/shared/entities/website-button/create-website-button'
import { createWebsiteHeader } from 'src/shared/entities/website-header/create-website-header'
import { createWebsiteLanguageSwitcher } from 'src/shared/entities/website-language-switcher/create-website-language-switcher'
import { createWebsiteLogo } from 'src/shared/entities/website-logo/create-website-logo'
import { LibraryElementEnum } from 'src/shared/enums/LibraryElementEnum'
import { WebsiteLibraryElementsCreator } from './website-library-elements-creator'

// NOTE: This class is for website pages
export class WebsiteLibraryElementsStructuresCreator extends CommonLibraryElementsStructuresCreator {
  constructor() {
    super(WebsiteLibraryElementsCreator)
  }

  protected [LibraryElementEnum.LibraryWebsiteButton](args: CreatorArgs) {
    return createWebsiteButtonFromLibrary({
      createButton: createWebsiteButton,
      ...args,
    })
  }

  protected [LibraryElementEnum.LibraryWebsiteLanguageSwitcher](
    args: CreatorArgs,
  ) {
    return createDefaultEntityStructure({
      createEntity: createWebsiteLanguageSwitcher,
      ...args,
    })
  }

  protected [LibraryElementEnum.LibraryWebsiteHeader](args: CreatorArgs) {
    return createDefaultEntityStructure({
      createEntity: createWebsiteHeader,
      ...args,
    })
  }

  protected [LibraryElementEnum.LibraryWebsiteLogo](args: CreatorArgs) {
    return createDefaultEntityStructure({
      createEntity: createWebsiteLogo,
      ...args,
    })
  }
  // ------------------------------
  // NOTE: website entity structure creators
  // ------------------------------
  // protected [LibraryElementEnum.LibraryWebsiteForm](args: CreatorArgs) {
  //   return createDefaultEntityStructure(
  //     {
  //       createEntity: this.createElement.createWebsiteForm,
  //       ...args
  //     }
  //   )
  // }
  // ------------------------------
}
